import { Flex, Image, Loader } from '@mantine/core';
import AppIcon from '@/components/AppIcon.tsx';
import { HiMiniExclamationCircle, HiOutlineDocument } from 'react-icons/hi2';
import { useMemo } from 'react';
import { datasetToFileTypeAndIcon } from '@/pages/AutomationPage/components/DatasetItemUtils.ts';

import { Dataset } from '@/types/datasets.ts';

type props = {
  dataset?: Dataset;
  size?: string;
  borderRadius?: string | number;

  showPlaceholderIcon?: boolean;
};

const DatasetIcon = ({
  dataset,
  size = '16px',
  borderRadius = '4px',
  showPlaceholderIcon = false,
}: props) => {
  const Icon = useMemo(() => {
    if (showPlaceholderIcon) {
      return <AppIcon Icon={HiOutlineDocument} iconProps={{ color: '#757575' }} size={size} />;
    }

    // 1️⃣ Handle error or processing states first
    if (dataset?.processing_error) {
      return (
        // <Tooltip label={dataset.processing_error} openDelay={250}>
        <AppIcon
          Icon={HiMiniExclamationCircle}
          iconProps={{ color: '#EE393C' }}
          size={size}
          style={{ backgroundColor: 'transparent' }}
        />
        // </Tooltip>
      );
    }

    const datasetProcessing = dataset?.unprocessed && !dataset?.processing_error;

    if (!dataset || datasetProcessing) {
      return (
        <Loader style={{ '--loader-size': size, animationDuration: '1.0s' }} color="#51ADFF" />
      );
    } else {
      const { icon } = datasetToFileTypeAndIcon(dataset);
      return (
        <Image src={icon} height={size} fit="contain" w="unset" style={{ borderRadius: '4px' }} />
      );
    }
  }, [dataset, showPlaceholderIcon, size]);

  return (
    <Flex
      style={{
        borderRadius: borderRadius,
        boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.04), 0 3px 6px -2px rgba(0, 0, 0, 0.02)',
      }}
    >
      {Icon}
    </Flex>
  );
};

export default DatasetIcon;
